import { Container, Row, Col, Button, Form, Modal } from 'react-bootstrap';
import { useRef, useState, useEffect } from 'react';
import '../../App.css';
import '../../css/bootstrap.scss';
import email_icon from "../../images/email_icon.png";
import { Link } from 'react-router-dom';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import axios, { AxiosError } from 'axios';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../renderField';
import { connect } from 'react-redux';
import { setEmail, setResetPasswordWizardPageNumber, setPhoneNo } from '../ResetPasswordReducer';
import { RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import config from '../../config';
import { useTranslation } from 'react-i18next';
import { isEmailExist, validateEmail, getUserID, getUserData } from '../../Utils/user';
import { resendOtp, verifyOtp as verifyOtpRequest } from '../../Utils/otp';

interface Props { };
interface FormData {
    isEmailVerified: boolean;
}

const VerifyEmail: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const email = useSelector((state: RootState) => state.resetPassword.email);

    const page = useSelector((state: RootState) => state.resetPassword.wizardPageNumber);
    const [validated, setValidated] = useState(false);
    const [validatedEmpty, setValidatedEmpty] = useState(false);
    const [validatedSuccess, setValidatedSuccess] = useState(false);

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const [timer, setTimer] = useState(30);
    const [resendEnabled, setResendEnabled] = useState(false);

    useEffect(() => {
        let interval: any;

        if (timer > 0 && !resendEnabled) {
            interval = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        } else if (timer === 0 && !resendEnabled) {
            setResendEnabled(true);
        }

        return () => clearInterval(interval);
    }, [timer, resendEnabled]);

    const sendotp_baseURL = config.NODE_API_BASE_URL + '/twillio/sendSMSOTP';

    const startLoading = () => {
        setLoading(true);
    };

    var num1: any = useRef(null);
    var num2: any = useRef(null);
    var num3: any = useRef(null);
    var num4: any = useRef(null);
    var num5: any = useRef(null);
    var num6: any = useRef(null);

    const sendOTP = async (phoneNo: String) => {
        try {
            const sendOTP = await axios.post(sendotp_baseURL, {
                phoneNo: phoneNo
            }).catch((reason: AxiosError<{ additionalInfo: string }>) => {
                console.log(reason.response);
                if (reason.response?.status === 404) {
                    notifyError('OTP Failed');
                    return;
                } else if (reason.response?.status === 429) {
                    notifyError('Something Went Wrong');
                    return;
                } else {
                    notifyError('Something Went Wrong');
                    return;
                }
            });

            return sendOTP?.data;
        } catch (error: any) {
            console.error(error);
        }
    };

    const submitForm = async (formValues: FormData) => {
        setIsSubmitted(true);
        const userEnteredOtp = `${num1.current?.value}${num2.current?.value || ''}${num3.current?.value || ''}${num4.current?.value || ''}${num5.current?.value || ''}${num6.current?.value || ''}`;

        if (userEnteredOtp == '') {
            setValidatedEmpty(true);
            return;
        }
        startLoading();

        const userId = await getUserID(email);
        const Response = await verifyOtp(userEnteredOtp, userId);

        if (Response?.status && Response.status == 1) {
            const userData = await getUserData(userId);
            const phoneNo = userData['urn:scim:wso2:schema'].phoneNo;

            if (phoneNo) {
                dispatch(setPhoneNo(phoneNo));
                const response = await sendOTP(phoneNo);
                dispatch(setResetPasswordWizardPageNumber(page + 1));
            }
            dispatch(setResetPasswordWizardPageNumber(page + 2));
        }
    };

    const verifyOtp = async (userEnteredOtp: string, userId: string) => {
        try {
            const data = await verifyOtpRequest(email, userEnteredOtp);
            if (data?.status !== 1) {
                setValidated(true);
                fieldsEmpty();
            }
            return data;
        } catch (error: any) {
            console.error(error);
            setValidated(true);
            fieldsEmpty();
        }
    };

    const resendCode = async () => {
        try {
            setValidated(false);
            setValidatedEmpty(false);
            setValidatedSuccess(false);
            setResendEnabled(false);
            const data = await resendOtp(email);
            if (data?.status === 1) {
                setValidatedSuccess(true);
                const nextResendSeconds = data.nextResendAt
                    ? Math.max(Math.ceil((new Date(data.nextResendAt).getTime() - Date.now()) / 1000), 1)
                    : 30;
                setTimer(nextResendSeconds);
            } else if (data?.code === 'TOO_SOON' || data?.code === 'LOCKED' || data?.code === 'MAX_RESENDS_REACHED') {
                notifyError(data.msg || 'Please wait before requesting another code.');
                setTimer(data.retryAfterSeconds || 30);
            } else {
                notifyError('Something Went Wrong');
                setResendEnabled(true);
                fieldsEmpty();
            }
        } catch (error: any) {
            console.error(error);
            notifyError('Something Went Wrong');
            setResendEnabled(true);
            fieldsEmpty();
        }
    };

    const handleOtpInput = (e: React.ChangeEvent<HTMLInputElement>, nextInputRef: React.RefObject<HTMLInputElement> | null) => {
        const input = e.target;
        const value = input.value;
        setValidatedEmpty(false);
        setValidatedSuccess(false);
        setValidated(false);

        if (value.length === 1 && /^\d$/.test(value)) {
            if (nextInputRef && nextInputRef.current) {
                nextInputRef.current.focus();
            }
        } else {
            input.value = '';
        }
    };

    const fieldsEmpty = () => {
        num1.current.value = "";
        num2.current.value = "";
        num3.current.value = "";
        num4.current.value = "";
        num5.current.value = "";
        num6.current.value = "";
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        const pastedText = e.clipboardData.getData('text');

        if (/^\d+$/.test(pastedText) && pastedText.length === 6) {
            const otpArray = pastedText.split('');

            [num1, num2, num3, num4, num5, num6].forEach((ref, index) => {
                if (ref.current) {
                    ref.current.value = otpArray[index];
                }
            });

            if (num6.current) {
                num6.current.focus();
            }

            if (num6.current) {
                handleOtpInput({ target: { value: otpArray[5] } } as React.ChangeEvent<HTMLInputElement>, null);
            }

            e.preventDefault();
        }
    };

    const handleBackspace = (currentRef: React.RefObject<HTMLInputElement>, prevRef: React.RefObject<HTMLInputElement> | null) => {
        if (currentRef && currentRef.current) {
            if (currentRef.current.value === '') {
                if (prevRef && prevRef.current) {
                    prevRef.current.focus();
                }
                if (prevRef && prevRef.current) {
                    prevRef.current.value = '';
                }
            } else {
                currentRef.current.value = '';
            }
        }
    };

    return (
        <>
            <Header />
            <ToastBox />
            <Container fluid className='min-vh-custom'>
                <Row className=''>
                    <Col md={3} className='text-center ms-2'>
                        <div className='mt-5 py-4'></div>
                    </Col>
                </Row>
                <Row className=' mt-5 '>
                    <Col md={12} className=' text-center'>
                        <img src={email_icon} width={50} />
                        <h3 className='text-center mt-3'>{t('login.verify_email_title')}</h3>
                        <span className='fw-normal'>
                            {t('login.code_sent')} <br /><span className='fw-bold'> {email}. </span>{t('login.code_valid')}&nbsp;
                            <Link className='text-primary' to={""}>{t('login.change_email')}</Link>
                        </span>
                        <p className='fs-6 mt-3 letter-spacing-fix fw-medium'>{t('login.enter_code')}</p>
                        <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
                            <div className="input-group d-flex justify-content-center">
                                <div className="input-group d-flex justify-content-center">
                                    <input
                                        type="number"
                                        onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num2)}
                                        ref={num1}
                                        className='rounded-4 border border-1 otp-input'
                                        onPaste={handlePaste}
                                        onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num1, null)}
                                    />
                                    <input
                                        type="number"
                                        onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num3)}
                                        ref={num2}
                                        className='ms-2 rounded-4 border border-1 otp-input'
                                        maxLength={1}
                                        onPaste={handlePaste}
                                        onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num2, num1)}
                                    />
                                    <input
                                        type="number"
                                        onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num4)}
                                        ref={num3}
                                        className='ms-2 rounded-4 border border-1 otp-input'
                                        maxLength={1}
                                        onPaste={handlePaste}
                                        onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num3, num2)}
                                    />
                                    <input
                                        type="number"
                                        onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num5)}
                                        ref={num4}
                                        className='ms-2 rounded-4 border border-1 otp-input'
                                        maxLength={1}
                                        onPaste={handlePaste}
                                        onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num4, num3)}
                                    />
                                    <input
                                        type="number"
                                        onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num6)}
                                        ref={num5}
                                        className='ms-2 rounded-4 border border-1 otp-input'
                                        maxLength={1}
                                        onPaste={handlePaste}
                                        onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num5, num4)}
                                    />
                                    <input
                                        type="number"
                                        onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, null)}
                                        ref={num6}
                                        className='ms-2 rounded-4 border border-1 otp-input'
                                        maxLength={1}
                                        onPaste={handlePaste}
                                        onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num6, num5)}
                                    />
                                </div>
                                {validated && <p className='text-danger fw-bold small text-start mt-2 mb-0'>{t('common.otp_invalid')}</p>}
                                {validatedEmpty && <p className='text-danger fw-bold small text-start mt-2 mb-0'>{t('common.otp_enter_valid')}</p>}
                                {validatedSuccess && <p className='text-success fw-bold small text-start mt-2 mb-0'>{t('common.otp_sent')}</p>}
                            </div>
                            <div className='d-grid gap-2 col-md-3 mx-auto mt-4'>
                                <Button variant="primary" type="submit" className="btn btn-primary rounded-5 mt-3" disabled={(loading && isSubmitted && !validated)}>
                                    {loading && isSubmitted && !validated && (
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='mx-2'
                                        />
                                    )}
                                    <span>{t('common.submit')}</span>
                                </Button>{' '}
                            </div>
                        </Form>
                        <div className='mt-3'>
                            <span>
                                {t('common.didnt_receive')}{' '}
                                {resendEnabled ? (
                                    <Link className='text-primary' to={''} onClick={resendCode}>
                                        {t('common.resend_code')}
                                    </Link>
                                ) : (
                                    <span>{t('common.try_again_in', 'Try again in')} <span className='text-primary'>{timer}s</span></span>
                                )}
                            </span>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Footer full={true} />
        </>
    );
};


const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
})(VerifyEmail);

export default connect(null)(form);
